import { FC } from "react"
import { TranslationKey } from "@/modules/i18n"
import { ChallengeService } from "@duck/api-definitions"
import { AssignmentTab } from "./WorkspaceTabs/Assignment/Assignment.tab"
import { SolutionTab } from "./WorkspaceTabs/Solution/Solution.tab"
import { SqlTab } from "./WorkspaceTabs/Sql/Sql.tab"
import { NotesTab } from "./WorkspaceTabs/Notes/Notes.tab"
import { SqlCheatSheetTab } from "./WorkspaceTabs/SqlCheatSheet/SqlCheatSheet.tab"

export type WorkspaceTabComponentProps = {
  data?: string
  onUpdateData?: (data: string) => void
  isVisible?: boolean
}

export type WorkspaceTabsItem = {
  label: TranslationKey
  Component: FC<WorkspaceTabComponentProps>
  onlyOne?: boolean
}

const AssignmentTabWrapper: FC<WorkspaceTabComponentProps> = () => <AssignmentTab />

const SolutionTabWrapper: FC<WorkspaceTabComponentProps> = () => <SolutionTab />

const NotesTabWrapper: FC<WorkspaceTabComponentProps> = () => <NotesTab />

const SqlTabWrapper: FC<WorkspaceTabComponentProps> = ({ data, onUpdateData, isVisible }) => (
  <SqlTab query={data} onUpdateData={onUpdateData} isVisible={isVisible} />
)

const SqlCheatSheetTabWrapper: FC<WorkspaceTabComponentProps> = () => <SqlCheatSheetTab />

export const workspaceTabsDefinitions: Record<ChallengeService.WorkspaceTabTypeEnum, WorkspaceTabsItem> = {
  [ChallengeService.WorkspaceTabTypeEnum.Assignment]: {
    label: "common.assignment",
    Component: AssignmentTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Solution]: {
    label: "common.solution",
    Component: SolutionTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Sql]: {
    label: "common.sql",
    Component: SqlTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.Notes]: {
    label: "common.notes",
    Component: NotesTabWrapper,
  },
  [ChallengeService.WorkspaceTabTypeEnum.SqlCheatSheet]: {
    label: "common.sqlCheatSheet",
    Component: SqlCheatSheetTabWrapper,
  },
}

export const workspaceTabsOrder: ChallengeService.WorkspaceTabTypeEnum[] = [
  ChallengeService.WorkspaceTabTypeEnum.Assignment,
  ChallengeService.WorkspaceTabTypeEnum.Sql,
  ChallengeService.WorkspaceTabTypeEnum.Solution,
  ChallengeService.WorkspaceTabTypeEnum.Notes,
  ChallengeService.WorkspaceTabTypeEnum.SqlCheatSheet,
]